import {
  type OpenDockOrgReport,
  type OpenDockOrgReportDownload,
} from 'managed-analytics/domain/OpenDockOrgReport'

export type RawOpenDockOrgReport = {
  uuid: string
  org_id: string
  report_date: string
  uploaded_at: string
}

export type RawOpenDockOrgReportDownload = {
  url: string
}

export function mapApiToOpenDockOrgReports(
  reports: Array<RawOpenDockOrgReport>
): Array<OpenDockOrgReport> {
  return reports.map(report => ({
    uuid: report.uuid,
    orgId: report.org_id,
    reportDate: report.report_date,
    uploadedAt: report.uploaded_at,
  }))
}

export function mapApiToOpenDockOrgReportDownload(
  download: RawOpenDockOrgReportDownload
): OpenDockOrgReportDownload {
  return {
    url: download.url,
  }
}
